
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon awesome-phone-alt","d":"M62.18 45.22l-14-6a3 3 0 00-3.51.87l-6.2 7.57a46.32 46.32 0 01-22.15-22.15l7.58-6.2a3 3 0 00.86-3.5l-6-14A3 3 0 0015.32.08l-13 3A3 3 0 000 6a58 58 0 0058 58 3 3 0 002.92-2.33l3-13a3.05 3.05 0 00-1.75-3.45z"}})])
          )
        }
      }
    